import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GeneralSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GeneralSettingsQuery = { __typename?: 'Query', generalSettings?: { __typename?: 'GeneralSettingsObjectType', index?: number | null } | null };


export const GeneralSettingsDocument = gql`
    query GeneralSettings {
  generalSettings {
    index
  }
}
    `;

/**
 * __useGeneralSettingsQuery__
 *
 * To run a query within a React component, call `useGeneralSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeneralSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GeneralSettingsQuery, GeneralSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralSettingsQuery, GeneralSettingsQueryVariables>(GeneralSettingsDocument, options);
      }
export function useGeneralSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralSettingsQuery, GeneralSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralSettingsQuery, GeneralSettingsQueryVariables>(GeneralSettingsDocument, options);
        }
export type GeneralSettingsQueryHookResult = ReturnType<typeof useGeneralSettingsQuery>;
export type GeneralSettingsLazyQueryHookResult = ReturnType<typeof useGeneralSettingsLazyQuery>;
export type GeneralSettingsQueryResult = Apollo.QueryResult<GeneralSettingsQuery, GeneralSettingsQueryVariables>;